module.exports = __webpack_public_path__ + "blank-webhook.2ac8b669579bd835796163f09e6addc6.svg";